export enum COLORS {
  BLUE = '#4bb1f8',
  BLUE_OPACITY = 'rgba(75,177,248,0.2)',
  BLUE_50 = 'rgba(75,177,248,0.5)',
  DARK_GRAY = '#536474',
  LIGHT_GRAY = '#989898',
  VERY_LIGHT_GRAY = '#BDBDBD',
  DULL = '#F5F7FF',
  GREEN = '#61C5C0',
  GREEN_2 = '#66DA51',
  GREEN_2_OPACITY = 'rgba(102,218,81,0.2)',
  LIGHT_GREEN = '#6FD19D',
  LIGHT_GREEN_2 = '#5CBCB6',
  TRANSLUCENT_GREEN = 'rgba(111,209,157,0.2)',
  RED = '#ff0000',
  RED_VARIANT = '#ff9e9e',
  RED_OPACITY = 'rgba(255,0,0,0.2)',
  TRANSPARENT = 'rgba(255,255,255,0)',
  WHITE = '#ffffff',
  BLACK = '#020202',
  ORANGE = '#ff9d0e',
}

export const EVIAN_COLORS = {
  bg: "#f7f8fa",
  panel: "#ffffff", // White
  text: "#505157", // Evian Grey 2018
  muted: "#6b7280",
  border: "#e5e7eb",
  borderStrong: "#d1d5db",
  primary: "#D50032", // Evian Red
  primaryOpacity: "rgba(213, 0, 50, 0.1)",
  primaryHover: "#b8002a", // Versión más oscura del Evian Red
  successBg: "#ecfdf5",
  successBorder: "#a7f3d0",
  successText: "#065f46",
  noteBg: "#f0fdf4",
  noteBorder: "#86efac",
  noteText: "#166534",
  errorBg: "#fef2f2",
  errorBorder: "#fecaca",
  errorText: "#dc2626",
  focusRing: "rgba(213, 0, 50, 0.35)",
  green: "#166534",
  lightGreen: "#f0fdf4",
  // Colores específicos para EvianSuccessScreen
  successIconBg: "#dcfce7",
  successIconColor: "#16a34a",
  cardBg: "#f0fdf4",
  cardBorder: "#bbf7d0",
  cardTitleColor: "#166534",
  cardTextColor: "#15803d",
  gradientEnd: "rgba(213, 0, 50, 0.1)",
  // Colores específicos para EvianLeaderBoard
  leaderboardBg: "#55BDCD", // Evian Turquoise
  leaderboardTitleGlow: "#00bfff",
  tableHeaderBg: "#007dc3",
  tableHeaderText: "#ffffff",
  tableRowEven: "#ffffff",
  tableRowOdd: "#f7aabc",
  tableText: "#007dc3",
  logoText: "#ffffff",
  mountainPeak: "#ffffff",
};
